import { render } from "./add-standardtests-modal.vue?vue&type=template&id=66828b46&ts=true"
import script from "./add-standardtests-modal.vue?vue&type=script&lang=ts"
export * from "./add-standardtests-modal.vue?vue&type=script&lang=ts"

import "./add-standardtests-modal.vue?vue&type=style&index=0&id=66828b46&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__